export default {
  recipient: {
    required: true,
    validateOnBlur: false,
  },
  subject: {
    required: true,
    maxLength: 100,
    validateOnBlur: false,
  },
  content: {
    required: true,
    maxLength: 2000,
    validateOnBlur: false,
  },
};
